import moment from "moment";

export class MonitoringErrorDetails {
  constructor(
    public id: string,
    public errorId: number,
    public platformId: number,
    public platformName: string,
    public channelId: number,
    public channelName: string,
    public availabilityZoneId: number,
    public availabilityZoneName: string,
    public count: number,
    public severity: number,
    public msg: string,
    public createdTime: moment.Moment,
    public resolvedTime?: moment.Moment,
  ) {}
}
